"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination/TablePagination"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function usePagination(count, initialRowsPerPage = 5, rowsPerPageOptions = [5, 10, 15, 20, 25]) {
    const [page, setPage] = (0, react_1.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, react_1.useState)(initialRowsPerPage);
    const [discoveredPages, setDiscoveredPages] = (0, react_1.useState)([]);
    const refreshPager = (0, event_callback_hook_1.useEventCallback)(() => {
        setPage(0);
        setDiscoveredPages([]);
    });
    const handleChangePage = (0, event_callback_hook_1.useEventCallback)((_, newPage) => {
        // Marks the page as discovered when it's leaved
        if (!discoveredPages.includes(page)) {
            setDiscoveredPages([...discoveredPages, page]);
        }
        setPage(newPage);
    });
    const handleChangeRowsPerPage = (0, event_callback_hook_1.useEventCallback)(async (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setDiscoveredPages([]);
        setPage(0);
    });
    const PaginationComponent = (0, react_1.useMemo)(() => function Pagination() {
        return (react_1.default.createElement(TablePagination_1.default, { page: page, count: count, component: "div", rowsPerPageOptions: rowsPerPageOptions, rowsPerPage: rowsPerPage, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, labelRowsPerPage: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_PAGED_TABLE_FIELD_ROWS_PER_PAGE", defaultMessage: "Po\u010Det zobrazen\u00FDch z\u00E1znam\u016F na str\u00E1nce:" }), labelDisplayedRows: ({ from, to, count }) => `${from}-${to} / ${count}` }));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, rowsPerPage, count]);
    return {
        PaginationComponent,
        page,
        rowsPerPage,
        discoveredPages,
        refreshPager,
    };
}
exports.usePagination = usePagination;
//# sourceMappingURL=paged-table-field-hook.js.map